var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJpaIcon = function SvgJpaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6CB52D",
    clipPath: "url(#jpa_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.09 7.299a17.4 17.4 0 0 1-2.14 3.745C36.323 7.348 31.25 5 25.652 5 14.653 5 5.667 13.937 5.667 24.975c0 5.767 2.467 10.959 6.38 14.625l.744.664a19.87 19.87 0 0 0 12.851 4.697c10.503 0 19.153-8.195 19.896-18.54.595-5.023-.931-11.453-3.448-19.122m-27.15 32.47c-.574.743-1.644.822-2.387.247-.743-.574-.823-1.645-.248-2.388s1.645-.822 2.388-.247c.704.574.822 1.645.248 2.388m27.031-5.975c-4.904 6.55-15.447 4.33-22.165 4.657 0 0-1.199.079-2.388.248 0 0 .456-.209 1.03-.417 4.737-1.644 6.966-1.981 9.85-3.458 5.4-2.764 10.79-8.818 11.87-15.08-2.061 6.014-8.323 11.206-14.01 13.307-3.915 1.446-10.96 2.843-10.96 2.843l-.287-.168c-4.776-2.348-4.944-12.732 3.795-16.072 3.835-1.486 7.461-.663 11.623-1.644 4.409-1.03 9.522-4.33 11.573-8.65 2.289 6.965 5.093 17.756.07 24.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.94 39.769c-.574.743-1.644.822-2.388.247-.743-.574-.822-1.645-.247-2.388.574-.743 1.645-.822 2.388-.247.703.574.822 1.644.247 2.388"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jpa_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.667 5h40v40h-40z"
  })))));
};
export default SvgJpaIcon;